import React, { useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./HelpSearch.module.css";
import { Col, Container, Row } from "react-bootstrap";
import useClickOutsideHook from "../../CustomHooks/useClickOutsideHook";
import { Button } from "../Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { DoubleCalander } from "../DoubleCalander/DoubleCalander";
import { useEffect } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import useDebounce from "../../CustomHooks/useDebounce";

export const HelpSearch = ({
  searchArray,
  onSubmitSearch,
  placeholder,
  setSelectedRole,
}) => {
  const [searchFocus, setSearchFoucs] = useState(false);

  const [searchRef] = useClickOutsideHook(() => setSearchFoucs(false));
  const [searchValue, setSearchValue] = useState(null);
  const debouncedSearch = useDebounce(searchValue, 500);
  const [isSearch, setIsSearch] = useState(false);
  const [role, setRole] = useState();

  useEffect(
    () => {
      if (debouncedSearch) {
        setSearchFoucs(true);
      }
    },
    [debouncedSearch] // Only call effect if debounced search term changes
  );

  // useMemo(() => console.log("isSearch", isSearch), [isSearch]);
  // useMemo(() => console.log("searchFocus", searchFocus), [searchFocus]);

  return (
    <Container
      className={` p-0 ${[classes.SearchBar].join(" ")}`}
      style={{ backgroundColor: Colors.white }}
    >
      <Row
        className={`g-0 ${[
          classes.customRow,
          searchFocus && classes.focus,
        ].join(" ")}`}
        onClick={() => {
          // setSearchFoucs(true);
          setIsSearch(false);
        }}
      >
        <Col
          md={10}
          className={`${[classes.innerContainer].join(" ")}`}
          ref={searchRef}
        >
          <Row
            className={`g-0 ${[classes.inputAndTitle].join(" ")}`}
            style={{ width: "100%" }}
          >
            <Col md={12}>
              <span
                htmlFor={`inputSearch`}
                className={[classes.title].join(" ")}
                style={{
                  color: Colors.neutralShadesOfNero,
                  ...Fonts.input3,
                }}
              >
                Search
              </span>
            </Col>
            <Col md={12}>
              <input
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setIsSearch(true);
                }}
                autoFocus={searchFocus}
                placeholder={placeholder}
                autocomplete="off"
                type={"text"}
                id={`inputSearch`}
                className={` ${[classes.input].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.p1,
                }}
              />

              {/* <CloseIcon
                color={"black"}
                style={{
                  position: "absolute",
                  right: "150px",
                  top: "34%",
                  opacity: searchFocus && searchValue?.length > 0 ? 1 : 0,
                }}
                onClick={() => {
                  setSearchValue("");
                  setter("");
                }}
              /> */}
            </Col>
          </Row>
        </Col>
        <Col md={2} className={`${[classes.innerContainer].join(" ")}`}>
          <Button
            primary={true}
            size={"Large"}
            label={"search"}
            disabled={false}
            onClick={() => {
              setSelectedRole(role);
              onSubmitSearch({ searchValue });
              setIsSearch(false);
            }}
            customStyle={{
              fontWeight: "normal",
              height: "56px",
            }}
          />
        </Col>
        {/* Search Options */}
        {searchFocus && isSearch && (
          <Col md={12}>
            <div className={[classes.searchOverlayContainer].join(" ")}>
              {searchArray.map((item, index) => (
                <>
                  <span
                    className={index > 0 && `${[classes.heading].join(" ")}`}
                    style={{
                      ...Fonts.p2,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    {item?.title}
                  </span>
                  {item?.categories?.map((cat) => {
                    return (
                      <p
                        className={classes.option}
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                        }}
                        onClick={() => {
                          setSelectedRole && setRole(item?.title);
                          setSearchValue(cat?.title);
                          setTimeout(() => {
                            setSearchFoucs(false);
                          }, 50);
                        }}
                      >
                        {cat?.title}
                      </p>
                    );
                  })}
                </>
              ))}
            </div>
          </Col>
        )}
      </Row>
      {/* Style */}
      <style jsx>{`
        .${classes.focus} {
          border-color: ${Colors.neutralShadesOfNero};
        }
      `}</style>
    </Container>
  );
};

HelpSearch.propTypes = {
  searchArray: PropTypes.array,
  onSubmitSearch: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

HelpSearch.defaultProps = {
  searchArray: [
    {
      title: "Coaches",
      categories: [
        {
          title: "How does LyteSnap work?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How do I become a LyteSnap Coach?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Keys for an outstanding coach application",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "Am I eligible to be a LyteSnap Coach?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
    {
      title: "Students",
      categories: [
        {
          title: "How do I find a coach and get started?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How much does it cost to book training sessions?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
        {
          title: "How can I reset my password or email?",
          description:
            "Lytesnap is a service that connects athletes with private coaches. Thousands of coaches across all sports use Lytesnap to build, market, and manage their private coaching business. Lytesnap provides online tools to make it easy for coaches to book, schedule, and receive payment for private training sessions. We encourage highly successful athletes and experienced coaches who want to be mentors, coaches, and positive influences for kids to sign up with Lytesnap.",
        },
      ],
    },
  ],
  locationArray: ["San Diego"],
  placeholder: "",
};
